/** Copyright (c) 2025 DAIA Tech Pvt Ltd. All rights reserved.
 *
 * This software is confidential and proprietary information of DAIA Tech Pvt Ltd
 * and its licensors. You shall not disclose such Confidential Information and shall
 * use it only in accordance with the terms of the license agreement.
 *
 * Unauthorized reproduction, modification, distribution, or disclosure of this
 * software is strictly prohibited.
 */

import { Route, Routes } from 'react-router-dom';
import { Report } from '@/components/Reports/Report';
import { Logout } from '@/screens/Logout';
import { Suspense } from 'react';
import { Loader } from '@/components/Loader';
import { lazy } from 'react';
import * as Sentry from '@sentry/react';

const SentryRoutes = Sentry.withSentryReactRouterV7Routing(Routes);

// Lazy load the components
const LoginRegister = lazy(() => import('@/screens/LoginRegister'));
const Main = lazy(() => import('@/screens/Main'));
const Reports = lazy(() => import('@/screens/reports/Index'));
const Dashboard = lazy(() => import('@/screens/reports/Dashboard'));

const Router = (
  <Suspense fallback={<Loader />}>
    <SentryRoutes>
      <Route path="/" element={<LoginRegister />} />
      <Route path="/login" element={<LoginRegister />} />
      <Route path="/register" element={<LoginRegister />} />
      <Route path="/logout" element={<Logout />} />
      <Route path="/*" element={<Main />} />
      <Route path="/mobile/reports" element={<Reports />} />
      <Route path="/mobile/reports/:id" element={<Report src="mobile" />} />
      <Route path="/mobile/reports/:kind/:id" element={<Report src="mobile" />} />
      <Route path="/web/reports/:id" element={<Report src="web" />} />
      <Route path="/web/reports/:kind/:id" element={<Report src="web" />} />
      <Route path="/web/reports/project/:id" element={<Dashboard src="web" />} />
    </SentryRoutes>
  </Suspense>
);

export default Router;
